import * as actionTypes from 'modules/auditModels/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @type {string[]} */
const initialState = [];

/**
 * @param {string[]} _
 * @param {import('modules/auditModels/types').FetchAuditModelsMySuccessAction} action
 */
const afterFetchMyAuditModels = (_, { payload }) => payload.content.map(({ auditModelId }) => auditModelId);

/**
 * @param {string[]} _
 * @param {import('modules/auditModels/types').DeleteAuditModelSuccessAction} action
 */
const removeOne = (state, { payload: auditModelId }) => state.filter(id => id !== auditModelId);

const reset = () => initialState;

export default createReducer(initialState, {
  [actionTypes.FETCH_AUDIT_MODELS_MY]: reset,
  [actionTypes.FETCH_AUDIT_MODELS_MY_SUCCESS]: afterFetchMyAuditModels,
  [actionTypes.DELETE_AUDIT_MODEL_SUCCESS]: removeOne,
});
